module.exports = __webpack_public_path__ + "img/Wp_2052.785fd174.png";